<template>
  <h6>unavailable view</h6>
</template>

<script>
export default {};
</script>

<style></style>
